import React from 'react';
import PropTypes from 'prop-types';

import withPillNavigation from '../../shared/withPillNavigation.decorator';
import AgGrid from '../../shared/agGrid/agGrid.component';
import { journalsPropTypes, localJournalsPropTypes } from '../../shared/propTypes';

import {
  defaultColumnDefs,
  journalsColumnDefs,
  localJournalsColumnDefs,
} from '../../shared/columnDefinitions/provisionQualitySingle';

const PillTypes = {
  JOURNAL: 'JOURNAL',
  LOCAL_JOURNAL: 'LOCAL_JOURNAL',
};

const PillDefinitions = [
  { label: 'Journals', type: PillTypes.JOURNAL },
  { label: 'Local Journals', type: PillTypes.LOCAL_JOURNAL },
];

const JournalsGrid = ({ activePill, journals, localJournals, isGridLoading }) => (
  <div className="single-provisions-grids">
    {activePill === PillTypes.JOURNAL
      ? <AgGrid
        columnDefs={journalsColumnDefs}
        defaultColDef={defaultColumnDefs}
        rowData={journals}
        isGridLoading={isGridLoading}
        withSearchBar
      />
      : <AgGrid
        columnDefs={localJournalsColumnDefs}
        defaultColDef={defaultColumnDefs}
        rowData={localJournals}
        isGridLoading={isGridLoading}
        withSearchBar
      />
    }
  </div>
);

JournalsGrid.propTypes = {
  activePill: PropTypes.oneOf(Object.values(PillTypes)).isRequired,
  isGridLoading: PropTypes.bool,
  journals: journalsPropTypes.isRequired,
  localJournals: localJournalsPropTypes.isRequired,
};

export default withPillNavigation(() => PillDefinitions)(JournalsGrid);
